// app/javascript/modules/url_manager.js
class UrlBuilder {
  constructor(basePath, panePath) {
    this.basePath = basePath;
    this.panePath = panePath;
  }

  build(slugs, currentBaseSlug) {
    const url = new URL(window.location);
    if (slugs.length === 0) {
      url.pathname = this.basePath;
      url.searchParams.delete("stacked");
    } else {
      const baseSlug = currentBaseSlug || slugs[0];
      url.pathname = `${this.panePath}/${baseSlug}`;
      url.searchParams.delete("stacked");
      slugs.filter(slug => slug !== baseSlug).forEach(slug => url.searchParams.append("stacked", slug));
    }
    return url;
  }
}

export class UrlManager {
  constructor(history = window.history) {
    this.history = history;
    this.urlBuilder = null; // Set in updateUrl with context
  }

  getSlugs() {
    const url = new URL(window.location);
    const pathParts = url.pathname.split('/').filter(Boolean);
    const baseSlug = pathParts.length > 2 && pathParts[pathParts.length - 2] === "zettel"
      ? pathParts[pathParts.length - 1]
      : null;
    const stackedSlugs = url.searchParams.getAll("stacked").filter(slug => slug && typeof slug === "string");
    return baseSlug ? [baseSlug, ...stackedSlugs] : stackedSlugs;
  }

  updateUrl(basePath, panePath, slugs) {
    this.urlBuilder = new UrlBuilder(basePath, panePath);
    const currentBaseSlug = this.getBaseSlugFromPath(window.location.pathname, panePath);
    const url = this.urlBuilder.build(slugs, currentBaseSlug);
    this.history.replaceState({ slugs }, document.title, url);

    // Dispatch custom event after URL update
    window.dispatchEvent(new CustomEvent('url:updated', { detail: { slugs } }));
  }

  getBaseSlugFromPath(pathname, panePath) {
    const pathParts = pathname.split('/').filter(Boolean);
    const paneParts = panePath.split('/').filter(Boolean);
    if (pathParts.length > paneParts.length && pathParts.slice(0, paneParts.length).join('/') === panePath) {
      return pathParts[paneParts.length];
    }
    return null;
  }
}
